import React from 'react';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';

import styles from './AutoStreamTracksPage.module.css';
import AutoStreamTracksPageContent from '../AutoStreamTracksPageContent';

const AutoStreamTracksPage = () => (
    <>
        <Typography
            variant='h4'
            component='h1'
            className={styles.page__title}
        >
            Страница управления треками автостримов
        </Typography>
        <Divider/>
        <AutoStreamTracksPageContent/>
    </>
);

export default AutoStreamTracksPage;
